import * as React from "react";
const ChevronLeft = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M15.0729595,5 L15.7800663,5.70710678 L9.41020654,12.074 L15.7800663,18.4363861 L15.0729595,19.1434929 L7.99920654,12.077895 L8.00220654,12.074 L8,12.0717464 L15.0729595,5 Z" }));
ChevronLeft.displayName = "ChevronLeft";
var ChevronLeft_default = ChevronLeft;
export {
  ChevronLeft_default as default
};
